import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { __experimentalGetSettings as getDateSettings } from '@wordpress/date';
/**
 * Internal dependencies
 */

import Tooltip from '../tooltip';
/**
 * Displays timezone information when user timezone is different from site timezone.
 */

var TimeZone = function TimeZone() {
  var _getDateSettings = getDateSettings(),
      timezone = _getDateSettings.timezone; // Convert timezone offset to hours.


  var userTimezoneOffset = -1 * (new Date().getTimezoneOffset() / 60); // System timezone and user timezone match, nothing needed.
  // Compare as numbers because it comes over as string.

  if (Number(timezone.offset) === userTimezoneOffset) {
    return null;
  }

  var offsetSymbol = timezone.offset >= 0 ? '+' : '';
  var zoneAbbr = '' !== timezone.abbr && isNaN(timezone.abbr) ? timezone.abbr : "UTC".concat(offsetSymbol).concat(timezone.offset);
  var timezoneDetail = 'UTC' === timezone.string ? __('Coordinated Universal Time') : "(".concat(zoneAbbr, ") ").concat(timezone.string.replace('_', ' '));
  return createElement(Tooltip, {
    position: "top center",
    text: timezoneDetail
  }, createElement("div", {
    className: "components-datetime__timezone"
  }, zoneAbbr));
};

export default TimeZone;
//# sourceMappingURL=timezone.js.map